// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

const SwiperGalleries = function() {

    //galeria basica (onde quiser)
    const galleryVideo = () => {

        const galVideo = document.querySelectorAll('.gallery-video');

        if (!galVideo) return;

        for (let i = 0; i < galVideo.length; i++) {

            let _parent = galVideo[i].closest('.parent_gal');

            galVideo[i].classList.add('swiper-container-gallery-video-' + i);
            _parent.querySelector('.swiper-button-prev').classList.add('swiper-video-button-prev-' + i);
            _parent.querySelector('.swiper-button-next').classList.add('swiper-video-button-next-' + i);

            const swiperVid = new Swiper('.swiper-container-gallery-video-' + i, {
                speed: 2000,
                loop: true,
                effect: 'slide',
                autoplay: false,
                navigation: {
                    prevEl: '.swiper-video-button-prev-' + i,
                    nextEl: '.swiper-video-button-next-' + i,
                },
                // autoplay        : {
                //     delay: 5000,
                //     disableOnInteraction: false,
                // },
            });

        }

    }

    //galeria basica (onde quiser)
    const galleryArrowLeft = () => {

        const galArrowLeft = document.querySelectorAll('.gallery-arror-left');


        if (!galArrowLeft) return;

        for (let i = 0; i < galArrowLeft.length; i++) {

            let _parent = galArrowLeft[i].closest('.parent_gal');

            galArrowLeft[i].classList.add('swiper-container-gallery-arror-left-' + i);
            _parent.querySelector('.swiper-button-prev').classList.add('swiper-arrow-left-button-prev-' + i);
            _parent.querySelector('.swiper-button-next').classList.add('swiper-arrow-left-button-next-' + i);
            _parent.querySelector('.swiper-pagination').classList.add('swiper-arrow-left-pagination-' + i);

            const swiperArrL = new Swiper('.swiper-container-gallery-arror-left-' + i, {
                speed: 2000,
                loop: true,
                effect: 'slide',
                autoplay: false,
                navigation: {
                    prevEl: '.swiper-arrow-left-button-prev-' + i,
                    nextEl: '.swiper-arrow-left-button-next-' + i,
                },
                pagination: {
                    clickable: true,
                    el: '.swiper-arrow-left-pagination-' + i,
                },
                // autoplay        : {
                //     delay: 5000,
                //     disableOnInteraction: false,
                // },
            });

        }

    }

    const galleryBasicSwiper = () => {

        const galBasic = document.querySelectorAll('.gallery-basic');

        if (!galBasic) return;

        for (let i = 0; i < galBasic.length; i++) {

            galBasic[i].classList.add('swiper-container-gallery-basic-' + i);

            const swiperHL = new Swiper('.swiper-container-gallery-basic-' + i, {
                speed: 2000,
                loop: true,
                effect: 'coverflow',
                //autoplay        : false,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });

        }

    }

    /*
    //galeria highlights
    const galleryHightlightsSwiper = () => {

        const galHighLights = document.querySelectorAll('.hightlightsSwiper');

        for( let i=0; i< galHighLights.length; i++ ) {
  
            galHighLights[i].classList.add('swiper-container-hightLight-' + i);

            const swiperHL = new Swiper('.swiper-container-hightLight-' + i, {
                slidesPerView   : 1,
                speed           : 2000,
                loop            : true,
                spaceBetween    : 14,
                effect          : 'slide',
                //autoplay        : false,
                autoplay        : {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                }
            });

            $(galHighLights[i]).closest('.wrap-swiper').find(".swiper-nav-left").on('click', function(e){
                e.preventDefault()
                swiperHL.slidePrev(1000);
            })
            $(galHighLights[i]).closest('.wrap-swiper').find(".swiper-nav-right").on('click', function(e){
                e.preventDefault()
                swiperHL.slideNext(1000);
            })

        }

    }

    //galeria designers
    const galleryDesignersSwiper = () => {

        const galDesigner = document.querySelectorAll('.galleryDesignersSwiper');

        for( let i=0; i< galDesigner.length; i++ ) {
  
            galDesigner[i].classList.add('swiper-container-designers-' + i);

            const swiperDesigners = new Swiper('.swiper-container-designers-' + i, {
                slidesPerView   : 1,
                speed           : 2000,
                loop            : true,
                spaceBetween    : 14,
                effect          : 'slide',
                //autoplay        : false,
                autoplay        : {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                }
            });

            $(galDesigner[i]).closest('.wrap-swiper').find(".swiper-nav-left").on('click', function(e){
                e.preventDefault()
                swiperDesigners.slidePrev(1000);
            })
            $(galDesigner[i]).closest('.wrap-swiper').find(".swiper-nav-right").on('click', function(e){
                e.preventDefault()
                swiperDesigners.slideNext(1000);
            })

        }

    } */

    return {

        init: () => {
            //gallerySwiperWebdoor();
            galleryVideo();
            galleryArrowLeft();
            // galleryBasicSwiper();
            // galleryHightlightsSwiper();
            // galleryDesignersSwiper();
        },

        // gallerySwiperWebdoor    : gallerySwiperWebdoor,
        // galleryBasicSwiper: galleryBasicSwiper,


        //    gallerySwiperWebdoor : gallerySwiperWebdoor()
        //teste : console.log('ufa')
    }

}();

export default SwiperGalleries;